import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';

interface HostedPaymentCheckoutProps {
  isOpen: boolean;
  onClose: () => void;
  checkoutUrl: string | null;
  providerLabel: string;
}

export const HostedPaymentCheckout = ({
  isOpen,
  onClose,
  checkoutUrl,
  providerLabel,
}: HostedPaymentCheckoutProps) => {
  const handleOpenExternal = () => {
    if (!checkoutUrl) return;
    window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl h-[88vh] p-0 overflow-hidden flex flex-col">
        <DialogHeader className="px-6 pt-6 pb-4 border-b">
          <DialogTitle>Paiement securise {providerLabel}</DialogTitle>
        </DialogHeader>

        {!checkoutUrl && (
          <div className="flex-1 flex items-center justify-center text-muted-foreground px-6">
            Impossible de charger la page de paiement.
          </div>
        )}

        {checkoutUrl && (
          <>
            <div className="px-6 py-3 border-b bg-muted/30 flex items-center justify-between gap-3">
              <p className="text-xs text-muted-foreground">
                Le paiement reste dans une fenetre integree. Si votre navigateur bloque l'integration, ouvrez en externe.
              </p>
              <Button type="button" variant="outline" size="sm" onClick={handleOpenExternal}>
                <ExternalLink className="h-4 w-4 mr-2" />
                Ouvrir en externe
              </Button>
            </div>

            <iframe
              title={`${providerLabel} Hosted Checkout`}
              src={checkoutUrl}
              className="w-full flex-1 border-0 bg-background"
              allow="payment *"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
